module.exports = __webpack_public_path__ + "img/uni_selection_white_arrow.702dfecd.svg";